import { DialogTitle } from '@mui/material';
import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { FC } from 'react';
import { useEmailArticleSender } from '../../../apollo/mutations/emailArticleMutation.topic.graphql';
import { EmailForm, EmailFormModel } from '../EmailForm';

interface EmailArticleDialogProps {
  rawArticleId: string;
  closeDialog: () => void;
}

export const EmailArticleDialog: FC<EmailArticleDialogProps> = ({
  rawArticleId,
  closeDialog,
}) => {
  const { pushNotification } = useNotification();
  const [sendEmailArticle] = useEmailArticleSender({
    onCompleted: () => {
      pushNotification({
        message: "L'article a correctement été envoyé.",
        type: NotificationTypeEnum.success,
      });
      closeDialog();
    },
    onError: () => {
      pushNotification({
        message: "Une erreur est survenue dans l'envoi de l'article.",
        type: NotificationTypeEnum.error,
      });
    },
  });

  const handleSubmit = ({ message, selectedUsers }: EmailFormModel) =>
    sendEmailArticle({
      variables: {
        rawArticle: rawArticleId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        recipients: selectedUsers.map((user) => user.email!),
        comment: message,
      },
    });

  return (
    <>
      <DialogTitle>Envoyer par email</DialogTitle>
      <EmailForm onCancel={closeDialog} onSubmit={handleSubmit} />
    </>
  );
};
